export class UIAdElements {
    constructor(){
        this.containerMainPageRightTop = document.getElementById('main_page_ad_right_top');
        this.containerMainPageRightMiddle = document.getElementById('main_page_ad_right_middle');
        this.containerMainPageRightBottom = document.getElementById('main_page_ad_right_bottom');
        this.containerGameLeft = document.getElementById('in_game_ad_left');
        this.containerGameRight = document.getElementById('in_game_ad_right');
        this.containerGameBottom = document.getElementById('in_game_ad_bottom');
        this.containerGameBottomSmall = document.getElementById('in_game_ad_bottom_small');
        this.modeSelectorAd = document.getElementById('mm-mode-selector-ad');
        this.removeAdInGameLeft = document.getElementById('remove_ad_in_game_left');
        this.removeAdInGameRight = document.getElementById('remove_ad_in_game_right');
    }
}
